import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import React, { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../../context";
import InformacionGeneral from "./components/InformacionGeneral";
import AprobarInfraccion from "./components/AprobarInfraccion";
import { getInfraccionConImagenes } from "./handlers";
import FormConsultarDatosPatente from "./components/Formularios/FormConsultarDatosPatente";
import FormCompletarAprobarInfraccion from "./components/Formularios/FormAprobarDenunia";
import CropTestREC from "./components/Formularios/CropTestREC";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { aprobarDenunciaSchema } from "./components/Formularios/schemas";
import { Lock } from "@mui/icons-material";
import { Alert } from "react-bootstrap";
import ModalDatosMCD from "../ModalDatosMCD/ModalDatosMCD";
import ModalAnularDenuncia from "../ModalAnularDenuncia/ModalAnularDenuncia";
import { getInfraccionAprobadaConImagenes } from "../../../screens/MCD/InfraccionesAprobadas/handlers";
import AfmDenuncia from "./components/AfmDenuncia";

const ModalInfraccionMCD = ({ infraccionesNuevas, setInfraccionesNuevas, aprobadas = false }) => {
  const { loads } = useGeneralAppStore();
  // const { infraccionesNuevas, setInfraccionesNuevas } = props;
  const { actions: ua } = useContext(UserContext);
  const [value, setValue] = useState("informacion_general");
  const [isLoading, setIsLoading] = useState(false);


  //*NUEVOOO
  const [datosTitular, setDatosTitular] = useState();
  const [fotoPatenteSeleccionada, setFotoPatenteSeleccionada] = useState(null);
  const [fotoInfraccion2, setFotoInfraccion2] = useState(null);
  const [fotoInfraccion3, setFotoInfraccion3] = useState(null);

  const formRef = useRef(null);
  const methods = useForm({
    mode: "all",
    resolver: yupResolver(aprobarDenunciaSchema),
    defaultValues: {
      id: infraccionesNuevas?.infraccion_seleccionada?.id,

      nombre: datosTitular?.razonSocial,
      // apellido_titular: datosTitular?.titular?.renaper?.apellido,
      documento: datosTitular?.documento,
      direccion_titular: datosTitular?.direccion_titular,
      // direccion_infraccion: ,
      provincia: datosTitular?.provincia,
      localidad: datosTitular?.localidad,
      codigo: datosTitular?.codigo_postal,
      // razonSocial: datosTitular?.titular?.nombre,

      patente: datosTitular?.dominio?.replaceAll("-", ""),
      marca: datosTitular?.vehiculo?.marca,
      modelo: datosTitular?.vehiculo?.modelo,

      latitud: infraccionesNuevas?.infraccion_seleccionada.latitud,
      longitud: infraccionesNuevas?.infraccion_seleccionada.longitud,
    },
  });

  const { modals, handlerModal } = useGeneralAppStore();

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const getInfraccionCompleta = async () => {
      if (aprobadas) {
        await getInfraccionAprobadaConImagenes(
          infraccionesNuevas.infraccion_seleccionada.id,
          setInfraccionesNuevas,
          setIsLoading
        );
      } else {
        await getInfraccionConImagenes(
          infraccionesNuevas.infraccion_seleccionada.id,
          setInfraccionesNuevas,
          setIsLoading
        );
      }
    };

    getInfraccionCompleta();

    return () => {
      setInfraccionesNuevas((prevState) => ({
        ...prevState,
        infraccion_seleccionada: null,
      }));
    };
  }, []);

  console.log(modals)
  console.log(infraccionesNuevas?.infraccion_seleccionada)

  return (
    <>
      {loads?.includes('detalle_denuncia') ? (
        <MuniSpinner2 />
      ) : (
        <Modal
          show={
            modals.includes("infraccion_mcd")
          }
          size={"xl"}
          // fullscreen={true}
          onHide={() => {
            handlerModal({ modal: false, modalName: "infraccion_mcd" });
            setInfraccionesNuevas((prevState) => ({
              ...prevState,
              infraccion_seleccionada: null,
            }));
          }}
          backdrop="static"
          title={() => `Infracción`}
        >
          <section style={{ minHeight: "80vh" }}>

            <div className="row">
              <div className="col-12  col-md-5  ">
                <InformacionGeneral
                  infraccion_seleccionada={infraccionesNuevas.infraccion_seleccionada}
                />

              </div>
              {(infraccionesNuevas.infraccion_seleccionada?.afm) ?
                (
                  <>
                    <div className="col-12  col-md-7  ">
                      <AprobarInfraccion
                        setInfraccionesNuevas={setInfraccionesNuevas}
                        infraccion_seleccionada={infraccionesNuevas.infraccion_seleccionada}
                      />
                    </div>
                    <AfmDenuncia afm={infraccionesNuevas.infraccion_seleccionada?.afm} />
                  </>
                )
                :
                (
                  <div className="col-12  col-md-7  ">
                    <AprobarInfraccion
                      setInfraccionesNuevas={setInfraccionesNuevas}
                      infraccion_seleccionada={infraccionesNuevas.infraccion_seleccionada}
                    />
                    <FormConsultarDatosPatente
                      infraccion_seleccionada={infraccionesNuevas?.infraccion_seleccionada}
                      setDatosTitular={setDatosTitular}
                    />
                  </div>
                )
              }

              {modals.includes("datos_mcd") && datosTitular && (
                <ModalDatosMCD
                  setInfraccionesNuevas={setInfraccionesNuevas}
                  infraccion_seleccionada={infraccionesNuevas?.infraccion_seleccionada}
                  datosTitular={datosTitular}
                  infraccionesNuevas={infraccionesNuevas}


                // setInfraccionesNuevas={setInfraccionesNuevas}
                />
              )}
              {modals.includes("anular_denuncia") && datosTitular && (
                <ModalAnularDenuncia
                  setInfraccionesNuevas={setInfraccionesNuevas}
                  infraccion_seleccionada={infraccionesNuevas?.infraccion_seleccionada}
                  datosTitular={datosTitular}
                  infraccionesNuevas={infraccionesNuevas}


                // setInfraccionesNuevas={setInfraccionesNuevas}
                />
              )}
            </div>
          </section>
        </Modal >
      )}
    </>
  );
};

export default ModalInfraccionMCD;
